module.exports = __webpack_public_path__ + "img/23.9d1a11d0.png";